export default function Button({ children, onClick, color, className }) {
  return (
    <button
      className={`${color === "pink" && "bg-pink"} ${
        color === "green" && "bg-green"
      } py-2 px-8 text-white rounded-sm transition-all ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
